import { RDFertilizer } from '@cibo/core'
import { Typography } from '@mui/material'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { DetailPanelTable } from '../DetailPanelTable'

export const FertilizerPanelTable = () => {
  const { t } = useTranslation('@cibo/landmanager/FertilizerPanelTable')
  const columns = useMemo(
    () => [
      {
        header: t('date'),
        cellContents: (applications?: RDFertilizer) => (
          <>
            {applications?.input?.events.map(({ date, ...rest }, idx) => (
              <Typography key={idx} variant="body2">
                {t('appliedDate', { date: new Date(date) })}
              </Typography>
            ))}
            {applications?.input?.events.length === 0 && '--'}
          </>
        ),
      },
      {
        header: t('type'),
        cellContents: (applications?: RDFertilizer) => (
          <>
            {applications?.input?.events.map(({ product, type }, idx) => (
              <Typography key={idx} variant="body2">
                {type ? t('appliedType', { context: type }) : product || '--'}
              </Typography>
            ))}
            {applications?.input?.events.length === 0 && '--'}
          </>
        ),
      },
      {
        header: t('perAcre'),
        cellContents: (applications?: RDFertilizer) => (
          <>
            {applications?.input?.events.map(({ rate, units }, idx) => (
              <Typography key={idx} variant="body2">
                {t('appliedAmtPerAcre', { amtPerAcre: t(`unit_${units}`), count: rate })}
              </Typography>
            ))}
            {applications?.input?.events.length === 0 && '--'}
          </>
        ),
      },
    ],
    []
  )
  return <DetailPanelTable<RDFertilizer> traitId="fertilizer" columns={columns} />
}
